import { useState, useEffect, useRef } from 'react';
import {
    Box,
    Stack,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormGroup,
    Checkbox,
    Button,
    Paper,
    Divider,
    Alert,
    Collapse,
    Chip,
    TextField,
    CardMedia,
    IconButton,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import ArticleIcon from '@mui/icons-material/Article';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { fetchParticularExercise, submitInject } from '../../../../RTK/features/participantProfile/participantProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { submitInjectCorporate } from '../../../../APIConfig/NewCorporateApiConfig';

const QuizSection = ({ data, inject, injectIndex, totalInjects, onScoreUpdate, onNextQuestion, id }) => {
    const [selectedAnswer, setSelectedAnswer] = useState('');
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [subjectiveAnswer, setSubjectiveAnswer] = useState('');
    const [uploadedFile, setUploadedFile] = useState(null);
    const [isAnswered, setIsAnswered] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const fileInputRef = useRef(null);
    // const { scenarioId } = useParams();
    const dispatch = useDispatch();
    const { exerciseDetails: scenarioDataFromRedux } = useSelector(state => state.participantProfile);

    console.log({ data, inject, injectIndex, totalInjects, onScoreUpdate, onNextQuestion }, 'innnnnnnnnnn')
    console.log(inject, 'injectinject')

    const hasEnded = scenarioDataFromRedux?.participant_ended === true;

    // Locks all inputs — either already answered or exercise has ended
    const isLocked = isAnswered || hasEnded;

    useEffect(() => {
        setSelectedAnswer('');
        setSelectedAnswers([]);
        setSubjectiveAnswer('');
        setUploadedFile(null);
        setShowFeedback(false);
        setIsCorrect(false);
        if (fileInputRef.current) fileInputRef.current.value = '';

        if (inject && inject?.status && inject?.status !== 'not_answered') {
            setIsAnswered(true);
            setShowFeedback(true);
            setIsCorrect(inject.status === 'correct');
        } else {
            setIsAnswered(false);
        }
    }, [inject]);

    if (!inject) {
        return (
            <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
                <Stack alignItems="center" spacing={2}>
                    <HelpOutlineIcon sx={{ fontSize: 64, color: '#454F5B' }} />
                    <Typography variant="body1" sx={{ color: '#637381' }}>
                        No questions available for this exercise.
                    </Typography>
                </Stack>
            </Box>
        );
    }

    const injectType = inject.inject_type;
    const sortedOptions = (injectType === 'mcq' || injectType === 'multiple_select' || injectType === 'true_false')
        ? [...(inject.options || [])].sort((a, b) => a.order - b.order)
        : [];

    const trueFalseOptions = injectType === 'true_false' && sortedOptions.length === 0
        ? [{ id: 'true', text: 'True', order: 1 }, { id: 'false', text: 'False', order: 2 }]
        : sortedOptions;

    const MIN_CHARS = injectType === 'short_answer' ? 1 : 50;
    const MAX_CHARS = injectType === 'short_answer' ? 1000 : 1500;

    const typeColor = {
        mcq: '#00B8D9',
        multiple_select: '#7C4DFF',
        true_false: '#00BFA5',
        short_answer: '#FFAB00',
        subject: '#FFAB00',
        media: '#9C27B0'
    };
    const typeLabel = {
        mcq: 'MCQ',
        multiple_select: 'MULTI-SELECT',
        true_false: 'TRUE/FALSE',
        short_answer: 'SHORT ANSWER',
        subject: 'SUBJECTIVE',
        media: 'MEDIA'
    };
    const severityColor = { low: '#36B37E', medium: '#FFAB00', high: '#FF5630', critical: '#B72136' };

    const handleAnswerChange = (e) => {
        if (!isLocked) setSelectedAnswer(e.target.value);
    };

    const handleMultiSelectChange = (optionId) => {
        if (isLocked) return;
        setSelectedAnswers((prev) =>
            prev.includes(optionId) ? prev.filter((id) => id !== optionId) : [...prev, optionId]
        );
    };

    const handleSubjectiveChange = (e) => {
        if (!isLocked) setSubjectiveAnswer(e.target.value);
    };

    const handleFileUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file || isLocked) return;
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            alert('File size must be less than 10MB');
            return;
        }
        setUploadedFile(file);
    };

    const handleRemoveFile = () => {
        setUploadedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    };

    const handleSubmitAnswer = async () => {
        const payload = {
            // delivery_id: inject.id,
            // active_scenario_id: scenarioDataFromRedux?.active_scenario_id
        };

        if (injectType === 'mcq' || injectType === 'true_false') {
            if (!selectedAnswer) return;
            payload.selected_option_ids = [selectedAnswer];
        } else if (injectType === 'multiple_select') {
            if (selectedAnswers.length === 0) return;
            payload.selected_option_ids = selectedAnswers;
        } else if (injectType === 'short_answer') {
            if (!subjectiveAnswer || subjectiveAnswer.trim().length < MIN_CHARS) return;
            payload.response_text = subjectiveAnswer;
        }

        try {

            const inject_id = inject?.id
            const response = await submitInjectCorporate(id, inject_id, payload)
            if (response) {
                setIsAnswered(true)
                setShowFeedback(true)
            }

            if (['mcq', 'true_false', 'multiple_select'].includes(injectType)) {
                setIsCorrect(true);
            }
            if (onScoreUpdate) onScoreUpdate((prev) => prev + (inject.points || 0));
        } catch (error) {
            console.error('Failed to submit answer:', error);
            alert('Failed to submit answer. Please try again.');
        }
    };

    const handleNextQuestion = () => {
        setSelectedAnswer('');
        setSelectedAnswers([]);
        setSubjectiveAnswer('');
        setUploadedFile(null);
        setIsAnswered(false);
        setShowFeedback(false);
        setIsCorrect(false);
        if (fileInputRef.current) fileInputRef.current.value = '';
        if (onNextQuestion) onNextQuestion();
    };

    const renderMediaContent = () => {
        if (injectType !== 'media') return null;
        const getMediaIcon = () => {
            switch (inject.mediaType) {
                case 'image': return <ImageIcon />;
                case 'video': return <VideoLibraryIcon />;
                default: return <ArticleIcon />;
            }
        };
        return (
            <Box sx={{ bgcolor: '#1C252E', p: 2, borderRadius: '12px', border: '1px solid #454F5B', mb: 3, }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                    <Box sx={{ color: '#00B8D9' }}>{getMediaIcon()}</Box>
                    <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                        Analyze the {inject.mediaType || 'content'} below:
                    </Typography>
                </Stack>
                {inject.mediaType === 'image' && inject.mediaUrl && (
                    <CardMedia component="img" image={inject.mediaUrl} alt="Evidence for analysis"
                        sx={{ borderRadius: '8px', border: '2px solid #454F5B', width: '100%', maxHeight: '400px', objectFit: 'contain' }} />
                )}
                {inject.mediaType === 'video' && inject.mediaUrl && (
                    <CardMedia component="video" src={inject.mediaUrl} controls
                        sx={{ borderRadius: '8px', border: '2px solid #454F5B', width: '100%', maxHeight: '400px' }} />
                )}
                {inject.mediaType === 'audio' && inject.mediaUrl && (
                    <audio controls src={inject.mediaUrl} style={{ width: '100%', borderRadius: '8px' }} />
                )}
            </Box>
        );
    };

    const renderMCQOptions = () => {
        if (injectType !== 'mcq') return null;
        return (
            <FormControl component="fieldset" fullWidth disabled={isLocked}>
                <RadioGroup value={selectedAnswer} onChange={handleAnswerChange}>
                    <Stack spacing={1.5}>
                        {sortedOptions.map((option) => {
                            const isSelected = selectedAnswer === String(option.id);
                            let borderColor = '#454F5B';
                            let bgColor = '#1C252E';
                            if (isLocked && isSelected) {
                                borderColor = isCorrect ? '#36B37E' : '#FF5630';
                                bgColor = isCorrect ? '#36B37E10' : '#FF563010';
                            } else if (!isLocked && isSelected) {
                                borderColor = '#00B8D9';
                                bgColor = '#00B8D920';
                            }
                            return (
                                <Paper key={option.id} sx={{
                                    bgcolor: bgColor,
                                    border: `2px solid ${borderColor}`,
                                    borderRadius: '12px',
                                    p: 2,
                                    transition: 'all 0.3s',
                                    cursor: isLocked ? 'not-allowed' : 'pointer',
                                    '& *': { cursor: `${isLocked ? 'not-allowed' : 'pointer'} !important` },
                                    '&:hover': !isLocked ? { borderColor: '#00B8D9', bgcolor: '#00B8D920' } : {},
                                }}
                                    onClick={() => !isLocked && setSelectedAnswer(String(option.id))}
                                >
                                    <FormControlLabel
                                        value={String(option.id)}
                                        control={
                                            <Radio sx={{
                                                color: '#637381',
                                                '&.Mui-checked': { color: isLocked ? (isCorrect ? '#36B37E' : '#FF5630') : '#00B8D9' },
                                            }} />
                                        }
                                        label={
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                                <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: isSelected ? 600 : 400 }}>
                                                    {option.text}
                                                </Typography>
                                                {isLocked && isSelected && isCorrect && <CheckCircleIcon sx={{ color: '#36B37E', fontSize: 20, ml: 2 }} />}
                                                {isLocked && isSelected && !isCorrect && <CancelIcon sx={{ color: '#FF5630', fontSize: 20, ml: 2 }} />}
                                            </Stack>
                                        }
                                        sx={{ width: '100%', m: 0 }}
                                    />
                                </Paper>
                            );
                        })}
                    </Stack>
                </RadioGroup>
            </FormControl>
        );
    };

    const renderMultiSelectOptions = () => {
        if (injectType !== 'multiple_select') return null;
        return (
            <FormControl component="fieldset" fullWidth disabled={isLocked}>
                <FormGroup>
                    <Stack spacing={1.5}>
                        {sortedOptions.map((option) => {
                            const isSelected = selectedAnswers.includes(String(option.id));
                            let borderColor = '#454F5B';
                            let bgColor = '#1C252E';
                            if (isLocked && isSelected) {
                                borderColor = isCorrect ? '#36B37E' : '#FF5630';
                                bgColor = isCorrect ? '#36B37E10' : '#FF563010';
                            } else if (!isLocked && isSelected) {
                                borderColor = '#7C4DFF';
                                bgColor = '#7C4DFF20';
                            }
                            return (
                                <Paper key={option.id} sx={{
                                    bgcolor: bgColor,
                                    border: `2px solid ${borderColor}`,
                                    borderRadius: '12px',
                                    p: 2,
                                    transition: 'all 0.3s',
                                    cursor: isLocked ? 'not-allowed' : 'pointer',
                                    '& *': { cursor: `${isLocked ? 'not-allowed' : 'pointer'} !important` },
                                    '&:hover': !isLocked ? { borderColor: '#7C4DFF', bgcolor: '#7C4DFF20' } : {},
                                }}
                                    onClick={() => handleMultiSelectChange(String(option.id))}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={isSelected} onChange={() => handleMultiSelectChange(String(option.id))}
                                                sx={{
                                                    color: '#637381',
                                                    '&.Mui-checked': { color: isLocked ? (isCorrect ? '#36B37E' : '#FF5630') : '#7C4DFF' },
                                                }} />
                                        }
                                        label={
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                                <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: isSelected ? 600 : 400 }}>
                                                    {option.text}
                                                </Typography>
                                                {isLocked && isSelected && isCorrect && <CheckCircleIcon sx={{ color: '#36B37E', fontSize: 20, ml: 2 }} />}
                                                {isLocked && isSelected && !isCorrect && <CancelIcon sx={{ color: '#FF5630', fontSize: 20, ml: 2 }} />}
                                            </Stack>
                                        }
                                        sx={{ width: '100%', m: 0 }}
                                    />
                                </Paper>
                            );
                        })}
                    </Stack>
                </FormGroup>
                {!isLocked && (
                    <Typography variant="caption" sx={{ color: '#637381', mt: 1 }}>
                        Select all that apply
                    </Typography>
                )}
            </FormControl>
        );
    };

    const renderTrueFalseOptions = () => {
        if (injectType !== 'true_false') return null;
        return (
            <FormControl component="fieldset" fullWidth disabled={isLocked}>
                <RadioGroup value={selectedAnswer} onChange={handleAnswerChange}>
                    <Stack direction="row" spacing={2}>
                        {trueFalseOptions.map((option) => {
                            const isSelected = selectedAnswer === String(option.id);
                            const optionColor = '#00BFA5';
                            let borderColor = '#454F5B';
                            let bgColor = '#1C252E';
                            if (isLocked && isSelected) {
                                borderColor = isCorrect ? '#36B37E' : '#FF5630';
                                bgColor = isCorrect ? '#36B37E10' : '#FF563010';
                            } else if (!isLocked && isSelected) {
                                borderColor = optionColor;
                                bgColor = `${optionColor}20`;
                            }
                            return (
                                <Paper key={option.id} sx={{
                                    flex: 1,
                                    bgcolor: bgColor,
                                    border: `2px solid ${borderColor}`,
                                    borderRadius: '12px',
                                    p: 2,
                                    transition: 'all 0.3s',
                                    cursor: isLocked ? 'not-allowed' : 'pointer',
                                    '& *': { cursor: `${isLocked ? 'not-allowed' : 'pointer'} !important` },
                                    '&:hover': !isLocked ? { borderColor: optionColor, bgcolor: `${optionColor}20` } : {},
                                }}
                                    onClick={() => !isLocked && setSelectedAnswer(String(option.id))}
                                >
                                    <FormControlLabel
                                        value={String(option.id)}
                                        control={
                                            <Radio sx={{
                                                color: '#637381',
                                                '&.Mui-checked': { color: isLocked ? (isCorrect ? '#36B37E' : '#FF5630') : optionColor },
                                            }} />
                                        }
                                        label={
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                                <Typography variant="body1" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                                                    {option.text}
                                                </Typography>
                                                {isLocked && isSelected && isCorrect && <CheckCircleIcon sx={{ color: '#36B37E', fontSize: 20, ml: 2 }} />}
                                                {isLocked && isSelected && !isCorrect && <CancelIcon sx={{ color: '#FF5630', fontSize: 20, ml: 2 }} />}
                                            </Stack>
                                        }
                                        sx={{ width: '100%', m: 0 }}
                                    />
                                </Paper>
                            );
                        })}
                    </Stack>
                </RadioGroup>
            </FormControl>
        );
    };

    const renderShortAnswerInput = () => {
        if (injectType !== 'short_answer') return null;
        return (
            <Box>
                <TextField
                    multiline
                    rows={6}
                    fullWidth
                    variant="outlined"
                    placeholder="Type your answer here..."
                    value={subjectiveAnswer}
                    onChange={handleSubjectiveChange}
                    disabled={isLocked}
                    inputProps={{ maxLength: MAX_CHARS }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            bgcolor: '#1C252E',
                            color: '#FFFFFF',
                            '& fieldset': { borderColor: '#454F5B' },
                            '&:hover fieldset': { borderColor: isLocked ? '#454F5B' : '#00B8D9' },
                            '&.Mui-focused fieldset': { borderColor: '#00B8D9' },
                            '&.Mui-disabled': {
                                bgcolor: '#16181F',
                                cursor: 'not-allowed',
                                '& fieldset': { borderColor: '#454F5B' },
                            },
                        },
                        '& .MuiInputBase-input': {
                            color: '#FFFFFF',
                            cursor: isAnswered ? 'not-allowed' : 'text',
                            '&.Mui-disabled': {
                                cursor: 'not-allowed',
                                WebkitTextFillColor: '#919EAB',
                            },
                        },
                    }}
                />
                <Stack direction="row" justifyContent="flex-end" alignItems="center" mt={1}>
                    <Typography variant="caption" sx={{ color: subjectiveAnswer.length > 0 ? '#36B37E' : '#919EAB', fontWeight: 600 }}>
                        {subjectiveAnswer.length} / {MAX_CHARS}
                    </Typography>
                </Stack>
            </Box>
        );
    };

    const renderSubjectiveInput = () => {
        if (injectType !== 'subject' && injectType !== 'media') return null;
        return (
            <Box>
                <TextField
                    fullWidth
                    multiline
                    rows={6}
                    variant="outlined"
                    placeholder="Type your detailed answer here..."
                    value={subjectiveAnswer}
                    onChange={handleSubjectiveChange}
                    disabled={isLocked}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            bgcolor: '#1C252E',
                            color: '#FFFFFF',
                            '& fieldset': { borderColor: '#454F5B' },
                            '&:hover fieldset': { borderColor: isLocked ? '#454F5B' : '#00B8D9' },
                            '&.Mui-focused fieldset': { borderColor: '#00B8D9' },
                            '&.Mui-disabled': {
                                bgcolor: '#16181F',
                                cursor: 'not-allowed',
                                '& fieldset': { borderColor: '#454F5B' },
                            },
                        },
                        '& .MuiInputBase-input': {
                            color: '#FFFFFF',
                            cursor: isAnswered ? 'not-allowed' : 'text',
                            '&.Mui-disabled': {
                                cursor: 'not-allowed',
                                WebkitTextFillColor: '#919EAB',
                            },
                        },
                    }}
                />
                <Stack direction="row" justifyContent="space-between" alignItems="center" mt={1}>
                    <Typography variant="caption" sx={{ color: '#637381' }}>
                        Minimum {MIN_CHARS} characters required
                    </Typography>
                    <Typography variant="caption" sx={{ color: subjectiveAnswer.length >= MIN_CHARS ? '#36B37E' : '#919EAB', fontWeight: 600 }}>
                        {subjectiveAnswer.length} / {MAX_CHARS}
                    </Typography>
                </Stack>

                {injectType === 'media' && (
                    <Box sx={{ mt: 3 }}>
                        <Divider sx={{ borderColor: '#454F5B', my: 2 }} />
                        <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: 600, mb: 2 }}>
                            Upload Supporting Document{' '}
                            {inject.requiresFile && <span style={{ color: '#FF5630' }}>*</span>}
                        </Typography>
                        {!uploadedFile ? (
                            <Paper sx={{
                                bgcolor: '#1C252E',
                                border: '2px dashed #454F5B',
                                borderRadius: '12px',
                                p: 3,
                                textAlign: 'center',
                                cursor: isLocked ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s',
                                '&:hover': !isLocked ? { borderColor: '#00B8D9', bgcolor: '#00B8D910' } : {},
                            }}
                                onClick={() => !isLocked && fileInputRef.current?.click()}
                            >
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.zip"
                                    onChange={handleFileUpload}
                                    disabled={isLocked}
                                    style={{ display: 'none' }}
                                />
                                <CloudUploadIcon sx={{ fontSize: 48, color: isLocked ? '#454F5B' : '#637381', mb: 1 }} />
                                <Typography variant="body2" sx={{ color: isLocked ? '#454F5B' : '#FFFFFF', mb: 0.5 }}>
                                    {isLocked ? 'Uploads are closed' : 'Click to upload or drag and drop'}
                                </Typography>
                                {!isLocked && (
                                    <Typography variant="caption" sx={{ color: '#637381' }}>
                                        PDF, DOC, TXT, Images, ZIP (Max 10MB)
                                    </Typography>
                                )}
                            </Paper>
                        ) : (
                            <Paper sx={{ bgcolor: '#1C252E', border: '2px solid #36B37E', borderRadius: '12px', p: 2 }}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', bgcolor: '#36B37E20' }}>
                                            <InsertDriveFileIcon sx={{ color: '#36B37E' }} />
                                        </Box>
                                        <Box>
                                            <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                                                {uploadedFile.name}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#637381' }}>
                                                {formatFileSize(uploadedFile.size)}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    {!isLocked && (
                                        <IconButton onClick={handleRemoveFile} size="small" sx={{ color: '#FF5630', '&:hover': { bgcolor: '#FF563020' } }}>
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                </Stack>
                            </Paper>
                        )}
                        <Typography variant="caption" sx={{ color: '#637381', display: 'block', mt: 1 }}>
                            Upload your analysis report, screenshots, or supporting evidence
                        </Typography>
                    </Box>
                )}
            </Box>
        );
    };

    return (

        <Stack flexDirection={'coloumn'} height={'75vh'} gap={2}>

            {/* first section */}
            < Box sx={{ mt: 3, overflow: 'scroll', height: '90%' }}>
                <Divider sx={{ borderColor: '#454F5B', mb: 3 }} />

                {/* Question Header */}
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2} flexWrap="wrap" gap={1} >
                    <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" gap={1}>
                        <Typography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                            Question {injectIndex + 1} of {totalInjects}
                        </Typography>
                        <Chip
                            label={typeLabel[injectType] || injectType?.toUpperCase()}
                            size="small"
                            sx={{ bgcolor: `${typeColor[injectType] || '#637381'}20`, color: typeColor[injectType] || '#637381', fontWeight: 600, fontSize: '0.7rem', height: '20px' }}
                        />
                        {inject?.severity && (
                            <Chip
                                label={inject.severity.toUpperCase()}
                                size="small"
                                sx={{ bgcolor: `${severityColor[inject.severity.toLowerCase()] || '#637381'}20`, color: severityColor[inject.severity.toLowerCase()] || '#637381', fontWeight: 600, fontSize: '0.7rem', height: '20px' }}
                            />
                        )}
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
                        {inject.bonus_points > 0 && (
                            <Chip label={`+${inject.bonus_points} bonus`} size="small" sx={{ bgcolor: '#FFAB0020', color: '#FFAB00', fontWeight: 700 }} />
                        )}
                        <Chip label={`${inject.points ?? 0} pts`} size="small" sx={{ bgcolor: '#00B8D920', color: '#00B8D9', fontWeight: 700 }} />
                        {inject.max_answer_attempts && (
                            <Chip label={`${inject.max_answer_attempts} attempt${inject.max_answer_attempts !== 1 ? 's' : ''}`} size="small" sx={{ bgcolor: '#454F5B', color: '#919EAB', fontWeight: 600, fontSize: '0.7rem', height: '20px' }} />
                        )}
                    </Stack>
                </Stack>

                {/* Question Title */}
                <Box sx={{ bgcolor: '#1C252E', p: 2.5, borderRadius: '12px', border: '1px solid #454F5B', mb: 3 }}>
                    <Typography variant="body1" sx={{ color: '#FFFFFF', fontSize: '1.05rem', fontWeight: 500, lineHeight: 1.6 }}>
                        {inject.title}
                    </Typography>
                </Box>

                {/* Media Content */}
                {renderMediaContent()}

                {/* Answer Area */}
                {renderMCQOptions()}
                {renderMultiSelectOptions()}
                {renderTrueFalseOptions()}
                {renderShortAnswerInput()}
                {renderSubjectiveInput()}

                {/* Feedback */}
                <Collapse in={showFeedback}>
                    <Box sx={{ mt: 3 }}>
                        <Alert
                            severity="success"
                            icon={<CheckCircleIcon />}
                            sx={{
                                bgcolor: '#36B37E10',
                                border: '1px solid #36B37E40',
                                '& .MuiAlert-icon': { color: '#36B37E' },
                            }}
                        >
                            <Typography variant="body2" sx={{ color: '#FFFFFF', fontWeight: 600, mb: 0.5 }}>
                                Answer Submitted for Review :{" "}
                                {inject?.response_text ||
                                    inject?.selected_options?.[0]?.text}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#919EAB' }}>
                                {injectType === 'mcq'
                                    ? isCorrect
                                        ? `Great job! You earned ${inject.points ?? 0} points.`
                                        : ` Your answer has been submitted. Awaiting evaluation. `
                                    : 'Your answer has been submitted for evaluation.'}
                            </Typography>
                        </Alert>
                    </Box>
                </Collapse>
            </Box >

            {/* second section - action code*/}
            < Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ height: '10%' }}>
                {/* Hide Submit entirely when exercise has ended */}
                {
                    !isAnswered && !hasEnded ? (
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmitAnswer}
                            disabled={
                                (injectType === 'mcq' || injectType === 'true_false') ? !selectedAnswer :
                                    injectType === 'multiple_select' ? selectedAnswers.length === 0 :
                                        injectType === 'short_answer' ? subjectiveAnswer.trim().length < MIN_CHARS :
                                            subjectiveAnswer.length < MIN_CHARS
                            }
                            sx={{ px: 4, py: 1.5, fontWeight: 600, textTransform: 'none', fontSize: '1rem' }}
                        >
                            Submit Answer
                        </Button>
                    ) : isAnswered && injectIndex < totalInjects - 1 ? (
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleNextQuestion}
                            endIcon={<ArrowForwardIcon />}
                            sx={{ px: 4, py: 1.5, fontWeight: 600, textTransform: 'none', fontSize: '1rem' }}
                        >
                            Next Question
                        </Button>
                    ) : (
                        null
                    )
                }
            </Stack >
        </Stack >
    );
};

export default QuizSection;
